import { createSelector } from 'reselect'
import { selectBase } from './selectBase'

export const selectCurrentBillingCycle = createSelector(
  selectBase,
  base => base.billing_cycle
)
